import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Marketplace\EnableMarketplaceModuleController::__invoke
* @see app/Http/Controllers/Marketplace/EnableMarketplaceModuleController.php
* @route '/api/marketplace/module/{moduleId}/enable'
*/
const EnableMarketplaceModuleController = (args: { moduleId: string | number } | [moduleId: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: EnableMarketplaceModuleController.url(args, options),
    method: 'get',
})

EnableMarketplaceModuleController.definition = {
    methods: ["get","head"],
    url: '/api/marketplace/module/{moduleId}/enable',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Marketplace\EnableMarketplaceModuleController::__invoke
* @see app/Http/Controllers/Marketplace/EnableMarketplaceModuleController.php
* @route '/api/marketplace/module/{moduleId}/enable'
*/
EnableMarketplaceModuleController.url = (args: { moduleId: string | number } | [moduleId: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { moduleId: args }
    }

    if (Array.isArray(args)) {
        args = {
            moduleId: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        moduleId: args.moduleId,
    }

    return EnableMarketplaceModuleController.definition.url
            .replace('{moduleId}', parsedArgs.moduleId.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Marketplace\EnableMarketplaceModuleController::__invoke
* @see app/Http/Controllers/Marketplace/EnableMarketplaceModuleController.php
* @route '/api/marketplace/module/{moduleId}/enable'
*/
EnableMarketplaceModuleController.get = (args: { moduleId: string | number } | [moduleId: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: EnableMarketplaceModuleController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Marketplace\EnableMarketplaceModuleController::__invoke
* @see app/Http/Controllers/Marketplace/EnableMarketplaceModuleController.php
* @route '/api/marketplace/module/{moduleId}/enable'
*/
EnableMarketplaceModuleController.head = (args: { moduleId: string | number } | [moduleId: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: EnableMarketplaceModuleController.url(args, options),
    method: 'head',
})

export default EnableMarketplaceModuleController